import type { SelectOption } from "@/components/episto-ui/select";
import type { Webhook } from "@/types";

export const WEBHOOK_EVENT_OPTIONS: SelectOption[] = [
  { label: "Survey status changed", value: "survey_status_changed" },
  { label: "50% of target reached", value: "half_target_reached" },
];

export const WEBHOOK_STATUS_OPTIONS: SelectOption[] = [
  { label: "Draft", value: "draft" },
  { label: "Review", value: "review" },
  { label: "Live", value: "live" },
  { label: "Paused", value: "paused" },
  { label: "Complete", value: "complete" },
  { label: "Archive", value: "archive" },
];

const optionLabel = (options: SelectOption[], value: string | null): string =>
  options.find((option) => option.value === value)?.label ?? value ?? "";

export const webhookTriggerLabel = ({ event, target_status, delay_days }: Webhook): string => {
  const trigger =
    event === "survey_status_changed"
      ? `Status → ${optionLabel(WEBHOOK_STATUS_OPTIONS, target_status)}`
      : optionLabel(WEBHOOK_EVENT_OPTIONS, event);
  return delay_days ? `${trigger} (+${delay_days}d)` : trigger;
};
